(function ($, Drupal, once) {

  'use strict';

  // These are actually constants, but they will be initialized in the `attach`
  // function, because the block may be loaded via BigPipe.
  let searchContainer;
  let searchInput;
  let searchButton;

  Promutuel.search = {
    /**
     * Open the form and focus the input field.
     */
    openMainMenuForm() {
      if (!searchContainer) return;

      Promutuel.header?.show();
      Promutuel.header?.openMobileMenu();
      searchContainer.classList.add('search-form--opened');
      searchInput.setAttribute('aria-hidden', false);
      searchInput.focus();
    },

    closeMainMenuForm() {
      if (!searchContainer) return;
      // Ignore this on mobile: the input must always remain focusable.
      if (Promutuel.responsive?.getCurrentSize() < Promutuel.responsive?.BREAKPOINTS.LG) return;

      searchContainer.classList.remove('search-form--opened');
      searchInput.setAttribute('aria-hidden', true);
      searchInput.tabIndex = -1;
    },

    launch(query) {
      if (!searchContainer) return;

      if (query) searchInput.value = query;
      searchInput.dispatchEvent(new KeyboardEvent('keyup', { 'keyCode': 13 }));
    },
  }

  Drupal.behaviors.promutuel_search = {
    attach: function attach(context) {
      searchContainer = document.querySelector('.js-search-form');
      if (!searchContainer) return;

      searchInput = searchContainer.querySelector("input[type='search']");
      searchButton = searchContainer.querySelector("input[type='submit']");

      $(once('promutuel_search', searchButton, context)).each(function () {
        // Make sure the form is closed, with aria attributes positioned.
        Promutuel.search.closeMainMenuForm();

        // Handle clicks on search button.
        searchButton.addEventListener('click', _ => {
          // Mobile display.
          if (Promutuel.responsive?.getCurrentSize() < Promutuel.responsive?.BREAKPOINTS.LG) {
            if (searchInput.value) Promutuel.search.launch();
          }
          // Desktop display.
          else {
            // If the header searchbar is closed, open it.
            if (!searchContainer.classList.contains('search-form--opened')) {
              Promutuel.search.openMainMenuForm();
            }
            // If the form is active but empty, close it (does nothing on mobile).
            else if (!searchInput.value) {
              Promutuel.search.closeMainMenuForm();
            }
            // If the form is open and the field contains something, validate the search.
            else {
              Promutuel.search.launch();
            }
          }

          // Cancel the default submit action (everything is handled by SS360).
          return false;
        });

        // Close SearchForm if the user clicks anywhere outside it.
        document.body.addEventListener('click', event => {
          if (searchContainer.contains(event.target)) return false;
          Promutuel.search.closeMainMenuForm();
        });
      });
    }
  };
})(jQuery, Drupal, once);
